import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { Button, Tooltip } from "@dhis2/ui";
import { Configuration } from "../../assets/data/config";
import { useActivityLogger } from "../../hooks/useActivityLogger";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import ApprovalNotification from "./ApprovalNotification";

const ApprovalManagement = ({ stateFilter, periodFilter, facilityFilter }) => {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [approvalRequests, setApprovalRequests] = useState([]);

  const baseURL =
    process.env.NODE_ENV === "development"
      ? "http://localhost:9000/mrunner_api"
      : `${window.location.protocol}//${window.location.host}/mrunner_api`;

  const { sessionUserBoValue } = useActivityLogger();

  const userId = sessionUserBoValue?.userCredentials?.id || null;

  const getApprovalRequests = async () => {
    try {
      setGlobalSpinner(true);
      const response = await axios.get(`${baseURL}/getApprovalRequests`);
      setApprovalRequests(response.data);
    } catch (error) {
      console.log("Error in fetching the approval requests...");
    } finally {
      setGlobalSpinner(false);
    }
  };

  useEffect(() => {
    getApprovalRequests();
  }, []);

  const submitForApproval = async () => {
    if (
      stateFilter === "All" ||
      facilityFilter === "All" ||
      periodFilter === "All"
    ) {
      swal({
        title: "Error",
        text: `The State, Facility or Period filter hasn't been set correctly. Please try again.`,
        icon: "error",
        button: "Close",
      });
      return;
    }
    // console.log("sessionUserBoValue", sessionUserBoValue);
    // console.log("Configuration", Configuration);
    const filtered = approvalRequests
      .filter(
        (a) =>
          a.state === stateFilter &&
          a.facility === facilityFilter &&
          a.period === periodFilter
      )
      .sort((a, b) =>
        moment(b.created_at, "YYYY-MM-DD hh:mm A").diff(
          moment(a.created_at, "YYYY-MM-DD hh:mm A")
        )
      );

    // console.log("filtered", filtered);
    if (
      filtered.length > 0 &&
      !(
        filtered[0].mne_status === "Rejected" ||
        filtered[0].final_status === "Rejected"
      )
    ) {
      swal({
        title: "Error",
        text: `The report for ${periodFilter} has already been submitted`,
        icon: "error",
        button: "Close",
      });
      return;
    }

    const obj = {
      report_name: "Monthly Report",
      state: stateFilter,
      facility: facilityFilter,
      period: periodFilter,
      submitted_by: sessionUserBoValue.displayName,
      submitted_at: moment().format("YYYY/MM/DD"),
      mne_status: "Pending",
      mne_remarks: "",
      mne_approval_date: null,
      final_status: "Pending",
      final_remarks: "",
      final_approval_date: null,
      facility_id: sessionUserBoValue?.organisationUnits?.[0]?.id || null,
      user_uid: userId,
    };
    // console.log("obj", obj);

    try {
      setGlobalSpinner(true);
      await axios.post(`${baseURL}/submitForApproval`, obj, {
        headers: { "Content-Type": "application/json" },
      });
      swal({
        title: "Success",
        text: "MPR submitted successfully...",
        icon: "success",
        button: "Close",
      });
      await axios.post(
        process.env.NODE_ENV === "development"
          ? `http://localhost:9000/mrunner_api/refreshDashboards`
          : `${window.location.protocol}//${window.location.host}/mrunner_api/refreshDashboards`,
        { r_id: 3 }
      );
    } catch (error) {
      console.log("Error while submitting MPR...", error);
      swal({
        title: "Error",
        text: "Error while submitting MPR...",
        icon: "error",
        button: "Close",
      });
    } finally {
      setGlobalSpinner(false);
      getApprovalRequests();
    }
  };

  return (
    <>
      {!Configuration.adminRoles.includes(
        sessionUserBoValue?.userCredentials?.userRoles[0].id
      ) && (
        <Tooltip content="Submit">
          <Button
            small
            type="button"
            value="default"
            className="ml-10px"
            onClick={submitForApproval}
          >
            Submit
            {/* for Approval */}
          </Button>
        </Tooltip>
      )}
      <ApprovalNotification />
      <Tooltip
        content={
          !Configuration.adminRoles.includes(
            sessionUserBoValue?.userCredentials?.userRoles[0].id
          )
            ? "Logs"
            : "Approval Requests"
        }
      >
        <Link className="nav-link" to="/layout/approvalRequests">
          <Button small type="button" value="default" className="ml-10px">
            {!Configuration.adminRoles.includes(
              sessionUserBoValue?.userCredentials?.userRoles[0].id
            )
              ? "Logs"
              : "Approval Requests"}
          </Button>
        </Link>
      </Tooltip>
    </>
  );
};

export default ApprovalManagement;
